export default __webpack_public_path__ + "static/media/dortmund.b07f31bd.svg";